import React, { Suspense } from 'react';
import { ConnectedRouter as Router } from 'react-router-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import App from '../pages/app';
import Login from '../pages/login';
import NotFoundPage from '../pages/common/NotFoundPage';
import TypologyAnalyzer from '../pages/trm/typologyAnalyzer';

export default (store) => {
  const PrivateRoute = ({ component: Component, ...rest }) => {
    const isAuthed = localStorage.getItem('id_token');
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthed ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{ pathname: '/login', state: { from: props.location } }}
            />
          )
        }
      />
    );
  };

  const LoginRedirectRoute = ({ component: Component, ...rest }) => {
    const isAuthed = localStorage.getItem('id_token');
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthed ? <Redirect to="/app" /> : <Component {...props} />
        }
      />
    );
  };

  const routes = (
    <Router history={store.history}>
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/app" />} />
          <Route
            exact
            path="/app/tm/app"
            render={() => <Redirect to="/app/tm/investigation" />}
          />
          <Route
            exact
            path="/app/tm"
            render={() => <Redirect to="/app/tm/investigation" />}
          />

          <Route
            exact
            path="/dev/typology-analyzer"
            component={TypologyAnalyzer}
          />
          <PrivateRoute path="/app" component={App} />
          <LoginRedirectRoute path="/login" component={Login} />
          <Route path="*" component={NotFoundPage} />
        </Switch>
      </Suspense>
    </Router>
  );

  return routes;
};
